import classes from "./AttributionComponent.module.css";
import AttributionBox from "./AttributionBox";
import RepeatCustomerBox from "./RepeatCustomerBox";
import {
  getActiveBranchIds1,
  getBranchInfobyId,
} from "../util/multipleBranch/getActiveBranchId";
import getAttributionDataById from "../util/AttributionAnalysis/getData";
export default function AttributionComponent() {
  let data = JSON.parse(sessionStorage.getItem("attribution"));
console.log("attribution data", data);
  let activeBranches = getActiveBranchIds1();
  // console.log("active branches", activeBranches);

  // to check if questions have atrribution related q or not cuz only then this section
  // be shown
  let q = JSON.parse(localStorage.getItem("questions"))?.attribution;
  if (q == null || q == undefined) q = [];

  return (
    <>
      {q.length > 0 && data != null && (
        <div className={classes.container}>
          <h3>Attribution Analysis</h3>
          {activeBranches.map((branch, index) => {
            return (
              <div key={`hfd${index}`}>
                {getBranchInfobyId(branch).name}
                <div className={classes.innerContainer}>
                  <div>
                    <RepeatCustomerBox data={getAttributionDataById(branch)} />
                  </div>

                  <div>
                    <AttributionBox data={getAttributionDataById(branch)} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}
